import { render, staticRenderFns } from "./OptometristProductin.vue?vue&type=template&id=33837c6a&scoped=true&"
import script from "./OptometristProductin.vue?vue&type=script&lang=js&"
export * from "./OptometristProductin.vue?vue&type=script&lang=js&"
import style0 from "./OptometristProductin.vue?vue&type=style&index=0&id=33837c6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33837c6a",
  null
  
)

export default component.exports